export default __webpack_public_path__ + "static/media/Frame_2049.6979ca3a.svg";